module.exports = __webpack_public_path__ + "static/media/HABITAT.4e91afdd.png";